import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-6251def3")

_pushScopeId("data-v-6251def3")
const _hoisted_1 = { class: "flex justify-between items-center px-6 py-4 border-b border-gray-200" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "text-xl font-semibold text-black-lp-300" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 cursor-pointer",
  alt: "x"
}, null, -1)
const _hoisted_5 = {
  class: "flex flex-col gap-y-4 overflow-y-auto",
  style: {"width":"578px","max-height":"514px"}
}
const _hoisted_6 = { class: "w-full border rounded-lg overflow-hidden shadow-sm" }
const _hoisted_7 = { class: "w-full border-collapse text-sm text-black-lp-300" }
const _hoisted_8 = { class: "bg-green-lp-200 text-white font-semibold" }
const _hoisted_9 = { class: "p-3 text-left" }
const _hoisted_10 = { class: "p-3 text-right" }
const _hoisted_11 = { class: "bg-white" }
const _hoisted_12 = { class: "p-3" }
const _hoisted_13 = { class: "p-3 text-right" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible = $event)),
    customBody: "p-4 px-6"
  }, {
    header: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.allDiscount")), 1)
        ]),
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = false))
        }, [
          _hoisted_4
        ])
      ])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("table", _hoisted_7, [
            _createVNode("thead", null, [
              _createVNode("tr", _hoisted_8, [
                _createVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.deliveryType")), 1),
                _createVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.percentage")), 1)
              ])
            ]),
            _createVNode("tbody", _hoisted_11, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
                return (_openBlock(), _createBlock("tr", {
                  key: index,
                  class: "border-t border-gray-lp-1400"
                }, [
                  _createVNode("td", _hoisted_12, _toDisplayString(item.productType), 1),
                  _createVNode("td", _hoisted_13, _toDisplayString(item.discount) + "%", 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})